import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const oauthClientApi = createApi({
  reducerPath: 'oauthClientApi',
  baseQuery: createBaseQuery('o_auth_clients', { timeout: 0 }),
  endpoints: builder => ({
    getOAuthClient: builder.query({
      query: ({ clientId, redirectUri }) =>
        `/${encodeURIComponent(clientId)}?${toQueryParams({ redirect_uri: redirectUri })}`,
    }),
  }),
});

export const { useLazyGetOAuthClientQuery } = oauthClientApi;
